import { render, staticRenderFns } from "./BodyModule.vue?vue&type=template&id=9160aad8&scoped=true"
import script from "./BodyModule.vue?vue&type=script&lang=js"
export * from "./BodyModule.vue?vue&type=script&lang=js"
import style0 from "./BodyModule.vue?vue&type=style&index=0&id=9160aad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9160aad8",
  null
  
)

export default component.exports